<template>
  <div :style="{ height: height + 'px', width: '100%' }"></div>
</template>

<script>
export default {
  name: "UiSpacer",
  props: {
    height: {
      type: Number,
      default: 20,
    },
  },
};
</script>